/* Regenis extras v4.3.
   v4.3 (2026-07-10): TEMP-HIDE block REMOVED. The popup was rebuilt Lirae-style
   (rgx-popup.js v4.0) and intentionally re-enabled; the CSS hide is gone because
   hiding a live popup visually while its JS kept arming an invisible overlay +
   scroll lock is exactly what froze the site. To disarm the popup, flip the
   RGX_POPUP_DISABLED kill-switch inside rgx-popup.js instead.
   v4.2 (2026-07-09): freeze fix, drawer pill truce. The
   sale pill used to be appended INSIDE .rgx-deal-pills, the holder that
   rgx-upsell-add.js rewrites with innerHTML on every sync \u2014 so upsell wiped the
   pill, this file's drawer observer re-added it, the re-add re-triggered
   upsell's observer, and the two scripts ping-ponged mutations + /cart.js
   fetches forever (page and theme editor "freezing"). The pill now lives in its
   own sibling .rgx-sale-pills holder that upsell never touches, the drawer
   observer ignores records from the reservation timer and the pill holders, and
   the rgx-disc-row class add is guarded so no-op calls stop rewriting the
   attribute.
   v4.1 (2026-07-07): mobile scroll-freeze + drawer
   discount amount. (a) rgxMotion (40ms hourglass-rotation ticker) removed \u2014 it
   wrote a style every 40ms forever; Clarity + Shopify pixel + upsell
   MutationObservers replayed every write (~25 callbacks/s). Hourglass is static.
   (b) soldBar/reviewsPill ticks no longer deAnim existing nodes
   (getAnimations({subtree:true}) every 900ms is costly); deAnim only at creation.
   (c) quietClassList on body + header section: Shrine's StickyHeader re-adds
   scrolled-past-header / header-hidden and re-removes body overflow-hidden on
   EVERY scroll event; a no-op classList call still rewrites the attribute (style
   recalc + observer fan-out \u2014 190+94 writes per 15s of scrolling measured).
   add/remove on those two elements now skip when token state already matches;
   end state identical. (d) drawer Discounts row: the -$xx.xx amount span (read
   as a price by shoppers) is hidden \u2014 the deal pills alone describe it; row
   tagged .rgx-disc-row by cartSalePill + a text-color-accent-1 CSS fallback so
   it never flashes pre-JS.
   v4.0: TEMP-HIDE block appended at EOF (mystery/scratch
   popup hidden site-wide per Jiwan 2026-07-06; delete that one block to restore).
   v3.9: '7 Reasons' advertorial spacing: banner-to-title gap
   halved (title margins zeroed; the wrap padding alone sets it) and the read-time
   pill sits evenly between the title and the byline (equal 14px margins).
   v3.8: glow is a constant subtle halo (static box-shadow),
   no animation; rgx-glow keyframes and the reduced-motion override removed.
   v3.7: 93% Sold \u2014 no card/outline (plain whitespace around
   it), the FILL itself is the sale-pill tan (#f7efdb / #e7d4a8) with a gold
   rgx-glow; mobile is exactly two lines (bar, then words). Drawer: sentence wrap
   reverted; the grey 'Free Shipping' caption under the truck (the theme's
   badge::after pseudo) is now the Save green (#17a34a) via CSS only.
   v3.6: 93% Sold section restyled as a tan card (matches
   the sale pill palette), stripes removed \u2014 solid maroon fill with an rgx-glow
   breathing box-shadow; drawer 'FREE shipping' wrapped in the same green as the
   Save text (#17a34a), re-applied by the drawer observer through re-renders.
   v3.5: the top pin no longer fires on the initial
   pageshow (that event lands at window load, after the person may already be
   scrolling \u2014 it yanked them back to the top once per visit). Pin now runs
   immediately at init and only again on back-forward-cache restores (persisted).
   v3.4: pages always open at the top \u2014 scrollRestoration
   set to manual + pageshow pin, so Safari's reload/tab-restore scroll memory can't
   reopen mid-page (anchor links exempt).
   v3.3: mobile fits without zoom \u2014 the sale pill wraps
   (flex:1, min-width:0) and the delivery row wraps, replacing the font-fitters that
   could bottom out and overflow the document (iOS then loads left-cropped, looking
   zoomed in); html/body overflow-x:clip on mobile so nothing can widen the layout
   viewport (clip, not hidden, so sticky/fixed keep working).
   v3.2: drawer sale pill is observer-backed: re-injected in
   the same mutation batch whenever a drawer re-render wipes it (was flickering
   between WELCOME10-only and both pills on the ~1s re-add interval).
   v3.1: sale pill can no longer be crushed by the row \u2014
   flex:0 0 auto and no min-width:0 (the box always wraps its text; the fitter
   alone controls size by shrinking the font until the ROW fits). v3.0: centered
   pill text, one-line delivery row with its own fitter, drawer sale deal-pill. */
(function () {
  var SALE_PILL_TEXT = '4th of July Sale';
  var FACES = [
    'https://cdn.shopify.com/s/files/1/0988/6993/6438/files/regenis-blog-customer2.png',
    'https://cdn.shopify.com/s/files/1/0988/6993/6438/files/regenis-blog-customer3.png',
    'https://cdn.shopify.com/s/files/1/0988/6993/6438/files/regenis-adv-author-f.png',
    'https://cdn.shopify.com/s/files/1/0988/6993/6438/files/regenis-adv-author.png',
    'https://cdn.shopify.com/s/files/1/0988/6993/6438/files/regenis-blog-author.png'
  ];

  function deAnim(el) {
    try {
      (el.getAnimations ? el.getAnimations({ subtree: true }) : []).forEach(function (a) {
        if (a.animationName && a.animationName.indexOf('rgx-') === 0) return;
        a.cancel();
      });
    } catch (e) {}
  }
  function visible(el) { return !!el && el.getClientRects().length > 0; }

  /* v4.1: Shrine's StickyHeader (scripts.js) calls classList.add/remove on the
     header section and body on EVERY scroll event; per spec a no-op add/remove
     still rewrites the class attribute, forcing a style recalc and fanning out to
     every MutationObserver on the page (Clarity, Shopify pixel, Kaching,
     rgx-upsell). Shadow add/remove on just those two elements to skip calls whose
     token state already matches. End state is always identical; toggle/replace
     and every other element are untouched. */
  function quietClassList(el) {
    if (!el || el.__rgxQuiet) return;
    el.__rgxQuiet = true;
    var cl = el.classList;
    var oa = DOMTokenList.prototype.add, orm = DOMTokenList.prototype.remove;
    cl.add = function () {
      for (var i = 0; i < arguments.length; i++) if (!cl.contains(arguments[i])) return oa.apply(cl, arguments);
    };
    cl.remove = function () {
      for (var i = 0; i < arguments.length; i++) if (cl.contains(arguments[i])) return orm.apply(cl, arguments);
    };
  }
  function rgxHeaderEl() { return document.querySelector('.shopify-section[id*="__header"]'); }

  function css() {
    if (document.getElementById('rgx-extras-css')) return;
    var s = document.createElement('style');
    s.id = 'rgx-extras-css';
    s.textContent =
      '.article-template__hero-container{display:none !important;}' +
      '#rgx-readbar{position:fixed;top:0;left:0;height:3px;background:#953333;width:0;z-index:10045;pointer-events:none;display:block !important;}' +
      '.rgx-readtime{display:flex !important;width:max-content;align-items:center;gap:.5rem;border:1px dashed #C49A9A;background:#FBF5F5;color:#7D2929;border-radius:6px;padding:.45rem 1rem;font-size:1.2rem;font-weight:600;letter-spacing:.02em;margin:1.2rem 0 .6rem;}' +
      '.rgx-readtime--inline{display:inline-flex !important;width:auto;vertical-align:middle;margin:0 0 0 1.2rem;transform:translateY(-0.12em);}' +
      '.rgx-readtime [class*="material-symbols"]{font-size:1.45rem;}' +
      '#rgx .rgx-title{margin:0;}' +
      '#rgx .rgx-readtime{margin:14px 0;}' +
      '#rgx-sold{display:flex !important;align-items:center;gap:1rem;background:none;padding:0;margin:1.4rem 0 .6rem;}' +
      '#rgx-sold .rgx-sold__track{display:block !important;flex:1 1 auto;min-width:0;height:12px;border-radius:99px;background:rgba(147,51,51,.12);}' +
      '#rgx-sold .rgx-sold__fill{display:block !important;position:relative;width:93%;height:100%;border-radius:99px;background:#f7efdb;border:1px solid #e7d4a8;box-sizing:border-box;box-shadow:0 0 6px 1px rgba(199,166,75,.45);}' +
      '#rgx-sold .rgx-sold__label{display:inline-block !important;color:#7D2929;font-weight:700;font-size:1.3rem;white-space:nowrap;}' +
      '#rgx-sold .rgx-sold__sep{display:inline-block !important;color:rgba(125,41,41,.45);font-weight:700;}' +
      '#rgx-sold .rgx-sold__batch{display:flex !important;align-items:center;gap:.4rem;color:rgba(125,41,41,.75);font-weight:600;font-size:1.2rem;white-space:nowrap;flex:0 0 auto;}' +
      '#rgx-sold .rgx-sold__batch [class*="material-symbols"]{font-size:1.4rem;display:inline-block !important;}' +
      '.product__info-wrapper div:has(> product-form.main-product-form){margin-top:10px !important;}' +
      '.product__info-wrapper .rg-pl__pill{display:inline-flex !important;align-items:center;justify-content:center;text-align:center;}' +
      '@media (max-width:749px){' +
        'html,body{overflow-x:clip;}' +
        '#rgx-sold{flex-wrap:wrap;gap:.6rem .8rem;}' +
        '#rgx-sold .rgx-sold__track{flex-basis:100%;}' +
        '#rgx-sold .rgx-sold__label{font-size:1.35rem;}' +
        '#rgx-sold .rgx-sold__batch{font-size:1.25rem;}' +
        '#rgx-sold .rgx-sold__batch [class*="material-symbols"]{font-size:1.45rem;}' +
        '.rgx-reviews{width:100%;flex-wrap:wrap;border-radius:14px;padding:.85rem 1.3rem;gap:.55rem 1rem;}' +
        '.rgx-reviews__stars{font-size:1.5rem;order:1;}' +
        '.rgx-reviews__avatars{order:2;margin-left:auto;}' +
        '.rgx-reviews__avatars img{width:2.6rem;height:2.6rem;margin-left:-0.8rem;}' +
        '.rgx-reviews__text{order:3;flex-basis:100%;font-size:1.3rem;white-space:normal;}' +
        '.product__info-wrapper .rg-pl{display:flex;align-items:center;flex-wrap:nowrap !important;gap:1rem;min-width:0;max-width:100%;}' +
        '.product__info-wrapper .rg-pl__now{font-size:1.9rem !important;}' +
        '.product__info-wrapper .rg-pl__was{font-size:1.4rem !important;}' +
        '.product__info-wrapper .rg-pl__pill{white-space:normal;flex:1 1 auto !important;min-width:0;font-size:1.35rem !important;line-height:1.3;padding:.5em .8em !important;}' +
        '.product__info-wrapper .rg-deliv8{display:flex !important;align-items:center;justify-content:space-between;flex-wrap:wrap !important;gap:.3rem 1rem;font-size:1.25rem !important;}' +
        '.product__info-wrapper .rg-deliv8 *{font-size:inherit !important;white-space:nowrap;}' +
      '}' +
      '' +
      '.rgx-reviews{display:inline-flex !important;align-items:center;gap:1rem;background:#F7F7F7;border-radius:999px;padding:.65rem 1.5rem .65rem 1.6rem;}' +
      '.rgx-reviews__stars{color:#E8A33D;font-size:1.8rem;letter-spacing:.1em;line-height:1;}' +
      '.rgx-reviews__text{color:#1c1c1c;font-size:1.45rem;font-weight:500;white-space:nowrap;}' +
      '.rgx-reviews__avatars{display:flex !important;}' +
      '.rgx-reviews__avatars img{width:3rem;height:3rem;border-radius:50%;object-fit:cover;border:2px solid #fff;margin-left:-0.85rem;display:block !important;}' +
      '.rgx-reviews__avatars img:first-child{margin-left:0;}';
    document.head.appendChild(s);
  }

  function isArticle() { return /\/blogs\//.test(location.pathname); }

  /* v4.1: ease() + rgxMotion() removed — the 40ms hourglass ticker was the main
     PDP mutation source; the hourglass icon is static now. */

  /* v3.3: fitTo/fitRows removed \u2014 the pill and delivery rows now wrap via CSS,
     which always fits; the shrink-to-fit approach could hit its minimum font size
     and still overflow, widening the document. */

  /* v4.2: the sale pill lives in its OWN .rgx-sale-pills holder, a sibling of
     upsell's .rgx-deal-pills \u2014 upsell rewrites its holder with innerHTML on every
     sync and used to wipe the pill when it shared that node. */
  function cartSalePill() { return;
  }

  function readBar() {
    if (document.getElementById('rgx-readbar')) return;
    var b = document.createElement('div');
    b.id = 'rgx-readbar';
    document.body.appendChild(b);
    deAnim(b);
    function upd() {
      var max = (document.documentElement.scrollHeight - window.innerHeight) || 1;
      var p = Math.min(100, Math.max(0, (window.scrollY / max) * 100));
      b.style.width = p.toFixed(2) + '%';
    }
    window.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    setInterval(upd, 400);
    upd();
  }

  function readTime() {
    if (document.querySelector('.rgx-readtime')) return;
    var body = document.querySelector('.article-template__content, .article-template .rte, article .rte, .rte');
    if (!body) return;
    var words = (body.textContent || '').trim().split(/\s+/).length;
    if (words < 100) return;
    var lo = Math.max(1, Math.round(words / 260));
    var hi = Math.max(lo, Math.round(words / 170));
    var label = lo === hi ? (lo + ' Minute Read') : (lo + '\u2013' + hi + ' Minute Read');
    var h = document.querySelector('#rgx .rgx-title') || document.querySelector('.article-template__title, .article-template h1, article h1, main h1');
    var date = h && h.parentElement ? h.parentElement.querySelector('.circle-divider') : null;
    var p = document.createElement('div');
    p.className = 'rgx-readtime';
    p.innerHTML = '<span class="material-symbols-outlined">schedule</span>Estimated ' + label;
    var anchor = visible(date) ? date : (visible(h) ? h : null);
    if (anchor) anchor.insertAdjacentElement('afterend', p);
    if (!visible(p)) {
      var hh = body.querySelector('h1, h2');
      if (hh) { p.classList.add('rgx-readtime--inline'); hh.appendChild(p); }
      else body.insertBefore(p, body.firstChild);
    }
    deAnim(p);
    setTimeout(function () { deAnim(p); }, 150);
    setTimeout(function () { deAnim(p); }, 600);
  }

  function soldBar() { return; /* v4.4 (2026-07-18): 93% Sold bar removed per Jiwan. Restore by deleting this early return. */
    var existing = document.getElementById('rgx-sold');
    if (existing) return;
    var d = new Date(Date.now() + 14 * 864e5);
    var batch = d.toLocaleDateString('en-US', { month: 'long', day: 'numeric' });
    var w = document.createElement('div');
    w.id = 'rgx-sold';
    w.innerHTML =
      '<div class="rgx-sold__track"><div class="rgx-sold__fill" style="width:93%;"></div></div>' +
      '<span class="rgx-sold__label">93% Sold</span>' +
      '<span class="rgx-sold__sep">\u2022</span>' +
      '<div class="rgx-sold__batch"><span class="material-symbols-outlined">hourglass_top</span>Order now or wait until ' + batch + '</div>';
    var placed = false;
    var pill = document.querySelector('.product__info-wrapper .rg-pl__pill');
    var info = document.querySelector('.product__info-wrapper product-info, .product__info-wrapper .product__info-container');
    if (pill && info && info.contains(pill)) {
      var node = pill;
      while (node.parentElement && node.parentElement !== info) node = node.parentElement;
      if (node.parentElement === info) { info.insertBefore(w, node); placed = true; }
    }
    if (!placed) {
      var anchor = document.querySelector('.product__info-wrapper .rg-bengrid') || document.querySelector('.product__info-wrapper .rg-pills');
      if (!anchor) return;
      anchor.insertAdjacentElement('afterend', w);
    }
    deAnim(w);
    setTimeout(function () { deAnim(w); }, 150);
    setTimeout(function () { deAnim(w); }, 600);
    setTimeout(function () { deAnim(w); }, 1500);
  }

  function reviewsPill(){}

  /* The drawer totals row gets periodically re-rendered (OCU cart widget / theme
     cart refresh), which wiped the sale pill; this observer re-injects in the
     SAME mutation batch, before paint, so the pill is never visibly absent.
     cartSalePill's id guard makes the observer's own feedback a no-op.
     v4.2: records from the reservation timer and the pill holders are ignored so
     routine ticks / pill writes can't wake this observer at all. */
  var pillWatched = null;
  var PILL_IGNORE = '.cart-timer, .rgx-sale-pills, .rgx-deal-pills';
  function watchDrawerPill() {
    var dr = document.querySelector('cart-drawer');
    if (!dr) return;
    if (dr === pillWatched && document.contains(dr)) return;
    pillWatched = dr;
    try {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var t = muts[i].target;
          var el = t.nodeType === 1 ? t : t.parentElement;
          if (el && el.closest && el.closest(PILL_IGNORE)) continue;
          cartSalePill();
          return;
        }
      }).observe(dr, { childList: true, subtree: true });
    } catch (e) {}
    cartSalePill();
  }

  function init() {
    /* v3.4: always open at the top. Safari restores the previous scroll position
       on reload / tab restore; scrollRestoration=manual disables that, and the
       pageshow pin also covers back-forward-cache restores. Anchor links exempt. */
    try { if ('scrollRestoration' in history) history.scrollRestoration = 'manual'; } catch (e) {}
    function toTop() { if (!location.hash) window.scrollTo(0, 0); }
    /* Only pin on back-forward-cache restores (persisted). The initial pageshow
       fires at window load \u2014 after the person may already be scrolling \u2014 and
       pinning there yanked them back to the top once per visit. */
    window.addEventListener('pageshow', function (e) { if (e.persisted) toTop(); });
    toTop();
    css();
    quietClassList(document.body);
    quietClassList(rgxHeaderEl());
    if (isArticle()) { readBar(); readTime(); setInterval(readTime, 900); }
    if (/\/products\//.test(location.pathname)) {
      soldBar(); reviewsPill();
      setInterval(function () { soldBar(); reviewsPill(); }, 900);
    }
    watchDrawerPill();
    setInterval(function () { watchDrawerPill(); cartSalePill(); quietClassList(rgxHeaderEl()); }, 900);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
